import { render, staticRenderFns } from "./OrderCreationModal.vue?vue&type=template&id=40c414d0&"
import script from "./OrderCreationModal.vue?vue&type=script&lang=js&"
export * from "./OrderCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports